import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "_flexwrap _ai-c _col-gap-2 _row-gap-0" }
const _hoisted_3 = { class: "_flex _ai-c _gap-1 _ov-h _grow-1 _flexb0 _mw-0 _order-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_divider = _resolveComponent("base-divider")
  const _component_base_text = _resolveComponent("base-text")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_balloon_actions = _resolveComponent("balloon-actions")

  return (_openBlock(), _createElementBlock("div", {
    "data-qa": `gift-card-row:${$props.giftCard.giftCardID}`
  }, [
    ($props.showDivider)
      ? (_openBlock(), _createBlock(_component_base_divider, { key: 0 }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_text, {
          as: "span",
          level: "b2",
          class: _normalizeClass($options.nameClasses),
          "data-qa": "gift-card-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.giftCard.name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["class"]),
        ($props.giftCard.publicNote)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 0,
              class: "_flexinline _pa-0 _tc--light _shrink-0",
              tag: "button",
              type: "button",
              "aria-label": $props.giftCard.publicNote,
              "icon-name": "circle-info",
              "vertical-position": "down",
              position: "left",
              "data-qa": "gift-card-message"
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.giftCard.publicNote), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["aria-label"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(_component_base_text, {
        as: "span",
        level: "caption",
        class: _normalizeClass($options.balanceClasses),
        "data-qa": "gift-card-balance"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.balanceLabel), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class"]),
      _createVNode(_component_balloon_actions, {
        class: "_order-2 _order-3--m _shrink-0 _ml-1--m",
        actions: $options.actions,
        "balloon-style-props": $options.balloonStyleProps,
        theme: "lightOutline",
        mode: $options.balloonActionsModes.grouped,
        "data-qa": "gift-card-actions"
      }, null, 8 /* PROPS */, ["actions", "balloon-style-props", "mode"])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}